import moment from "moment";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import autoTable from "jspdf-autotable";
import { formatChecklistQuestions } from "./checklist-pdf-helper";
import jsPDF from "jspdf";
import { toast } from "react-toastify";
import { STATE_LIST } from "../../../utils/state-list";
import { USER_ROLES } from "../../../utils/constants";

export const REASONS_FOR_ENGINE_REPLACEMENT = {
  new_engine: [
    "New List No",
    "Float Unavailability",
    "Very early hour failure",
  ],
  from_oem_plant: [
    "New List No",
    "Float Unavailability",
    "Very early hour failure",
  ],
  through_spd_mode: [
    "New List No",
    "Float Unavailability",
    "Very early hour failure",
  ],
};

export const convertPartsToString = (partsReplacementIds) => {
  return partsReplacementIds.map((p) => p).toString();
};
export const CUT_IN = [
  { label: "Post Cut-in", value: "POST_CUT_IN" },
  { label: "Pre Cut-in", value: "PRE_CUT_IN" },
  { label: "NA", value: "NA" },
];
const EXTEND_SUPPORT = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];
export const TICKET_STAGES = {
  NO_STAGE: "No Stage",
  COMPLAINT_FORM_SUBMITTED: "Complaint Form Submitted",
  COMPLAINT_FORM_UPDATED: "Complaint Form Updated",
  ENTER_ENGINE_DETAILS: "Enter Engine details",
  UNDER_WARRANTY: "Under Warranty",
  OUT_OF_WARRANTY: "Out of Warranty",
  ASSIGN_SE: "Assign Service Engineer",
  REASSIGN_SE: "Reassign Service Engineer",
  UPDATE_DEFECT_CODE: "Update Defect Code",
  UPDATE_ACTION_CODE: "Update Action Code",
  ENGINE_REPLACEMENT: "Engine Replacement",
  // PARTS_REPLACEMENT: "Parts Replacement",
  ENGINE_REPLACEMENT_REQ_SUBMITTED: "Engine Replacement Request Submitted",
  PARTS_REPLACEMENT_REQ_SUBMITTED: "Parts Replacement Request Submitted",
  ACTION_CODE_UPDATED: "Action Code Updated",
  COMMENT: "Comment",
  TICKET_UPDATED: "Ticket Updated",
  ATTACHMENT: "Attachment ",
  JIR_CREATED: "JIR Created",
  SUBMIT_JIR: "JIR under progress",
  "PART/S_REPLACEMENT": "Parts Replacement",
  APPROVER_ASSIGNED: "Approver Assigned",
  ENGINE_REPLACEMENT_APPROVED: "Engine Replacement Approved",
  ENGINE_REPLACEMENT_REJECTED: "Engine Replacement Rejected",
  WAITING_FOR_SE_ACKNOWLEDGEMENT:
    "Waiting For Service Engineer Acknowledgement",
  ADD_INSPECTION_DATE: "Add Inspection Date",
};
const TICKET_SEVERITY = [
  { label: "MINOR", value: "MINOR" },
  { label: "MAJOR", value: "MAJOR" },
];
export const BASIC_INFO_FORM_CONFIG = [
  {
    name: "stage",
    type: "text",
    label: "Next Action",
    placeholder: "Stage",
    disabled: true,
  },
  {
    name: "createdAt",
    type: "text",
    label: "Created On",
    placeholder: "Created On",
    disabled: true,
  },
  {
    name: "status",
    type: "text",
    label: "Ticket Status",
    placeholder: "Status",
    disabled: true,
  },
  {
    name: "engineSerialNumber",
    type: "text",
    label: "Engine Serial No.",
    placeholder: "Engine Serial No.",
    disabled: true,
  },
  {
    name: "listNumber",
    type: "text",
    label: "List Number",
    placeholder: "List Number",
    disabled: true,
  },
  {
    name: "extendedTechnicalSupport",
    type: "text",
    label: "Extend technical support",
    placeholder: "Extend technical support",
    disabled: true,
  },
  {
    name: "oemName",
    type: "text",
    label: "OEM Name",
    placeholder: "Oem Name",
    disabled: true,
  },
  {
    name: "oemServiceEngineerName",
    type: "text",
    label: "OEM service engineer name",
    placeholder: "OEM service engineer name",
    disabled: true,
  },
  {
    name: "oemServiceEngineerContact",
    type: "text",
    label: "OEM service engineer contact",
    placeholder: "OEM service engineer contact",
    disabled: true,
  },
  // {
  //   name: "repeatedComplaint",
  //   type: "text",
  //   label: "Repeated Complaint if any",
  //   placeholder: "Repeated Complaint",
  //   disabled: true,
  // },
  // {
  //   name: "cutInDetails",
  //   type: "autocomplete",
  //   label: "Cut-in",
  //   options: CUT_IN,
  //   placeholder: "Cut-in",
  // },

  // {
  //   name: "severity",
  //   type: "autocomplete",
  //   label: "Ticket Severity",
  //   options: TICKET_SEVERITY,
  //   placeholder: "Select",
  // },
];
export const AFTER_JIR_FORM = [
  {
    name: "serviceEngineer",
    type: "text",
    label: "Service Engineer Assigned",
    placeholder: "Service Engineer",
    disabled: true,
  },
  {
    name: "customerComplaintCode",
    type: "text",
    label: "Complaint Code",
    placeholder: "Complaint Code",
    disabled: true,
  },
  {
    name: "complaintDesc",
    type: "text",
    label: "Complaint Description",
    placeholder: "Complaint Description",
    disabled: true,
  },
  {
    name: "hmr",
    type: "text",
    label: "Complaint Hours",
    placeholder: "Complaint Hours",
    disabled: true,
  },
  {
    name: "state",
    type: "text",
    label: "State",
    placeholder: "Sate",
    disabled: true,
  },

  {
    name: "location",
    type: "text",
    label: "Location",
    placeholder: "Location",
    disabled: true,
  },
  {
    name: "engineModal",
    type: "text",
    label: "Engine Model",
    placeholder: "Engine Model",
    disabled: true,
  },
  {
    name: "engineerAssignedDate",
    type: "text",
    label: "Service engineer acknowledge date",
    placeholder: "Date",
    disabled: true,
  },
  {
    name: "dateOfInspection",
    type: "text",
    label: "Joint Inspection Date",
    placeholder: "Date",
    disabled: true,
  },
  {
    name: "defectCode",
    type: "text",
    label: "Defect Code",
    placeholder: "Defect Code",
    disabled: true,
  },
  {
    name: "defectDescription",
    type: "text",
    label: "Defect Description",
    placeholder: "Defect Description",
    disabled: true,
  },
  {
    name: "engineReplacementStatus",
    type: "text",
    label: "Engine Replacement Status",
    placeholder: "Engine Replacement Status",
    disabled: true,
  },
  {
    name: "engineReplacementCost",
    type: "text",
    label: "Engine Replacement Cost",
    placeholder: "Engine Replacement Cost",
    disabled: true,
  },
];
export const FINAL_ACTION_LIST = [
  {
    label: "Request  for Parts Replacement ",
    value: "Request  for Parts Replacement ",
  },
  {
    label: "Request for Engine Replacement",
    value: "Request for Engine Replacement",
  },
  {
    label: "Complaint Not Established",
    value: "Complaint Not Established",
  },
  {
    label: "Complaint not related to Engine – OEM to Address",
    value: "Complaint not related to Engine – OEM to Address",
  },
  {
    label: "Routed to Concerned proprietary supplier ",
    value: "Routed to Concerned proprietary supplier",
  },
  {
    label: "Adjusted / Solved – No parts changed",
    value: "Adjusted / Solved – No parts changed",
  },
  {
    label: "No Action Taken",
    value: "No Action Taken",
  },
];
export const BASIC_INFO_FORM_CONFIG2 = (serviceEngineers, formData2) => [
  {
    name: "engineer",
    type: "autocomplete",
    label: "Service engineer",
    options: serviceEngineers,
    placeholder: "Select service engineer",
  },
  {
    name: "additionalServiceEngineer",
    type: "autocomplete",
    label: "Additional Service engineer",
    options: serviceEngineers?.filter(
      (ele) => ele?.value !== formData2?.engineer?.value
    ),
    placeholder: "Select service engineer",
  },
  {
    name: "expertise",
    type: "autocomplete",
    label: "Expertise",
    options: serviceEngineers,
    placeholder: "Select expertise",
  },
  {
    name: "comment",
    type: "textarea",
    label: "Add Comment",
    placeholder: "comment",
    fieldGridSize: 12,
  },
];
export const BASIC_FORM2 = (ticketDetails) => [
  {
    label: "Invoice date",
    value:
      (ticketDetails?.invoiceDate &&
        moment(ticketDetails.invoiceDate).format("DD/MM/YYYY")) ||
      "-",
  },
  // { label: "List Number", value: ticketDetails.listNumber || "-" },
  // { label: "Plant", value: ticketDetails.plant || "-" },
];
export const BASIC_FORM3 = (ticketDetails, complaintForm) => [
  {
    label: "Complaint Code",
    value: ticketDetails.customerComplaintCode?.code || "-",
  },
  {
    label: "Complaint Description",
    value: complaintForm.investigationDetailsByOem || "-",
  },
  {
    label: "Defect Code",
    value: ticketDetails.defectCode
      ? `${ticketDetails.defectCode?.code} - ${ticketDetails.defectCode?.description}`
      : "-",
  },
  {
    label: "Action Code",
    value: ticketDetails.actionCode
      ? `${ticketDetails.actionCode?.code} - ${ticketDetails.actionCode?.description}`
      : "-",
  },
  { label: "Complaint Hours", value: ticketDetails.hmr || "-" },
  { label: "State", value: complaintForm.oemEngineLocation?.state || "-" },
  {
    label: "Location",
    value: complaintForm.oemEngineLocation?.tractorAddress || "-",
  },
];
export const INWARD_FORM1 = [
  {
    label: "Engine Replacement Approved on",
    name: "engineReplacementApprovedDate",
    type: "text",
    disabled: true,
    placeholder: "Engine Replacement Approved on",
    fieldGridSize: 3,
  },
  {
    label: "Engine Replacement Approved By",
    name: "assignedApprover",
    type: "text",
    disabled: true,
    placeholder: "Engine Replacement Approved By",
    fieldGridSize: 3,
  },
  // {
  //   label: "Name of Complaint",
  //   name: "customerComplaintCode",
  //   type: "text",
  //   disabled: true,
  //   placeholder: "Name of Complaint",
  //   fieldGridSize: 3,
  // },
  {
    label: "Engine Replacement Approval Mode",
    name: "underWarranty",
    type: "text",
    disabled: true,
    placeholder: "Engine Replacement Approval Mode",
    fieldGridSize: 3,
  },
  {
    label: "OEM",
    name: "oem",
    type: "text",
    disabled: true,
    placeholder: "OEM",
    fieldGridSize: 3,
  },
  {
    label: "Inspected By",
    name: "inspectedBy",
    type: "text",
    disabled: true,
    placeholder: "Inspected By",
    fieldGridSize: 3,
  },

  {
    label: "List Number",
    name: "listNumber",
    type: "text",
    disabled: true,
    placeholder: "List Number",
    fieldGridSize: 3,
  },
  {
    label: "Plant",
    name: "plant",
    type: "text",
    disabled: true,
    placeholder: "Plant",
    fieldGridSize: 3,
  },
  {
    label: "Hours Covered",
    name: "hmr",
    type: "text",
    disabled: true,
    placeholder: "Hours Covered",
    fieldGridSize: 3,
  },
  {
    label: "Field Warranty Engine Invoice Number",
    name: "invoiceNumber",
    type: "text",
    disabled: true,
    placeholder: "Field Warranty Engine Invoice Number",
    fieldGridSize: 3,
  },
  {
    label: "Field Warranty Engine Invoice Date",
    name: "invoiceDate",
    type: "text",
    disabled: true,
    placeholder: "Field Warranty Engine Invoice Date",
    fieldGridSize: 3,
  },
];
export const INWARD_FORM2 = [
  {
    label: "Field warranty engine inward date",
    name: "fieldWarrantyEngineInwardDate",
    type: "datePicker",
    required: true,
  },
  {
    label: "Complaint Engine Dispatch Date",
    name: "complaintEngineDispatchDate",
    type: "datePicker",
    required: true,
  },
  {
    label: "Transporter",
    name: "transporter",
    type: "text",
    required: true,
    placeholder: "Transporter",
  },
  {
    label: "Docket Number",
    name: "docketNumber",
    type: "text",
    required: true,
    placeholder: "Docket Number",
  },
  {
    label: "Engine Received Location",
    name: "engineReceivedLocation",
    type: "text",
    required: true,
    placeholder: "Engine Received Location",
  },
  {
    label: "State",
    name: "state",
    type: "autocomplete",
    options: STATE_LIST,
    required: true,
    placeholder: "State",
  },
  {
    label: "Dealers Name",
    name: "dealersName",
    type: "text",
    required: true,
    placeholder: "Dealers Name",
  },
  {
    label: "F.I.P No.",
    name: "fipNo",
    type: "text",
    required: true,
    placeholder: "F.I.P No.",
  },
  {
    label: "Field warranty reference Number",
    name: "fieldWarrantyReferenceNumber",
    type: "text",
    required: true,
    placeholder: "Field warranty reference Number",
  },
  {
    label: "Add Missing Items",
    name: "missingItems",
    type: "text",
    required: true,
    placeholder: "Add Missing Items",
  },
  {
    label: "Complaint Reference Number",
    name: "complaintReferenceNumber",
    type: "text",
    placeholder: "Complaint Reference Number",
  },
  {
    label: "Add Damaged Items",
    name: "damagedItem",
    type: "text",
    required: true,
    placeholder: "Add Damaged Items",
  },
  {
    label: "Joint Inspection ",
    name: "jointInspection",
    type: "text",
    required: true,
    placeholder: "Joint Inspection ",
  },
  {
    label: "SE Findings",
    name: "seFindings",
    type: "text",
    placeholder: "SE Findings",
  },
  {
    label: "Enclosure",
    name: "enclosure",
    type: "text",
    required: true,
    placeholder: "Enclosure",
  },
];
export const ADVANCE_FORM1 = [
  {
    label: "OEM",
    name: "oem",
    type: "text",
    disabled: true,
    placeholder: "OEM",
    fieldGridSize: 3,
  },

  {
    label: "List Number",
    name: "listNumber",
    type: "text",
    disabled: true,
    placeholder: "List Number",
    fieldGridSize: 3,
  },
  {
    label: "Plant",
    name: "plant",
    type: "text",
    disabled: true,
    placeholder: "Plant",
    fieldGridSize: 3,
  },
];
export const ADDITIONAL_ADVANCE_FORM1 = (oems) => [
  {
    label: "Engine Number",
    name: "advanceEngineNumber",
    type: "text",
    placeholder: "Engine Number",
    required: true,
    fieldGridSize: 3,
  },
  {
    label: "OEM Org",
    name: "oem",
    type: "autocomplete",
    options: oems,
    placeholder: "OEM",
    required: true,
    fieldGridSize: 3,
  },

  {
    label: "List Number",
    name: "listNumber",
    type: "text",
    placeholder: "List Number",
    required: true,
    fieldGridSize: 3,
  },
  {
    label: "Plant",
    name: "plant",
    type: "text",
    placeholder: "Plant",
    required: true,
    fieldGridSize: 3,
  },
];
export const ADVANCE_FORM2 = [
  {
    label: "Advance Engine Invoice No.",
    name: "advancedEngineInvoiceNo",
    type: "text",
    required: true,
    placeholder: "Advance Engine Invoice No.",
  },
  {
    label: "Advance Engine Invoice Date",
    name: "advancedEngineInvoiceDate",
    type: "datePicker",
    required: true,
    placeholder: "Advance Engine Invoice Date",
  },
  {
    label: "Invoice value",
    name: "invoiceValue",
    type: "text",
    required: true,
    placeholder: "Invoice value",
  },
  {
    label: "Tax Value",
    name: "taxValue",
    type: "text",
    required: true,
    placeholder: "Tax Value",
  },
  {
    label: "Depot Location",
    name: "depotLocation",
    type: "text",
    required: true,
    placeholder: "Depot Location",
  },
  {
    label: "Transporter",
    name: "transporter",
    type: "text",
    required: true,
    placeholder: "Transporter",
  },
  {
    label: "Docket Number",
    name: "docketNumber",
    type: "text",
    required: true,
    placeholder: "Docket Number",
  },
];
export const JIR_CONFIG = [
  {
    label: "Oem",
    name: "oem",
    type: "text",
    disabled: true,
    placeholder: "Oem",
    fieldGridSize: 3,
  },
  {
    label: "Location",
    name: "city",
    type: "text",
    disabled: true,
    placeholder: "Location",
    fieldGridSize: 3,
  },
  {
    label: "State",
    name: "state",
    type: "text",
    disabled: true,
    placeholder: "State",
    fieldGridSize: 3,
  },
  {
    label: "Date of Inspection",
    name: "dateOfInspection",
    type: "text",
    disabled: true,
    placeholder: "Date of Inspection",
    fieldGridSize: 3,
  },
  {
    label: "Simpsons Reps",
    name: "simpsonReps",
    type: "text",
    disabled: true,
    placeholder: "Simpsons Reps",
    fieldGridSize: 3,
  },
  // {
  //   label: "OEM Engg",
  //   name: "oemEngineer",
  //   type: "text",
  //   disabled: true,
  //   placeholder: "OEM Engg",
  //   fieldGridSize: 3,
  // },
  {
    label: "Engine Sl No.",
    name: "engineSerialNumber",
    type: "text",
    disabled: true,
    placeholder: "Engine Sl No.",
    fieldGridSize: 3,
  },
  {
    label: "Machine SL No.",
    name: "machineSerialNumber",
    type: "text",
    disabled: true,
    placeholder: "Machine SL No.",
    fieldGridSize: 3,
  },
  {
    label: "Date of Sale",
    name: "dateOfSale",
    type: "text",
    disabled: true,
    placeholder: "Date of Sale",
    fieldGridSize: 3,
  },
  {
    label: "Date of failure",
    name: "dateOfFailure",
    type: "text",
    disabled: true,
    placeholder: "Date of failure",
    fieldGridSize: 3,
  },
  {
    label: "Hours Covered",
    name: "hoursCovered",
    type: "text",
    disabled: true,
    placeholder: "Hours Covered",
    fieldGridSize: 3,
  },
  {
    label: "FIP No.",
    name: "fipNumber",
    type: "text",
    disabled: true,
    placeholder: "FIP No.",
    fieldGridSize: 3,
  },
  {
    label: "Complaint Description",
    name: "complaintDescription",
    type: "text",
    disabled: true,
    placeholder: "Complaint Description",
    fieldGridSize: 3,
  },
  {
    label: "Complaint Code",
    name: "complaintCodeOriginal",
    type: "text",
    disabled: true,
    placeholder: "Complaint Code",
    fieldGridSize: 3,
  },
  {
    label: "Application",
    name: "application",
    type: "text",
    disabled: true,
    placeholder: "Application",
    fieldGridSize: 3,
  },

  {
    label: "Regular Operation",
    name: "regularOperation",
    type: "text",
    disabled: true,
    placeholder: "Regular Operation",
    fieldGridSize: 3,
  },
  {
    label: "Implement Used During Failure",
    name: "implementUsedDuringFailure",
    type: "text",
    disabled: true,
    placeholder: "Implement Used During Failure",
    fieldGridSize: 3,
  },
  {
    label: "Field / Site condition",
    name: "fieldSiteCondition",
    type: "text",
    disabled: true,
    placeholder: "Field / Site condition",
    fieldGridSize: 3,
  },
  {
    label: "Customer Voice",
    name: "customerVoice",
    type: "text",
    disabled: true,
    placeholder: "Customer Voice",
    fieldGridSize: 3,
  },
  {
    label: "Whether Coolant/Water used in radiator",
    name: "radiatorCoolant",
    type: "text",
    disabled: true,
    placeholder: "Whether Coolant/Water used in radiator",
    fieldGridSize: 3,
  },
  {
    label: "Coolant Level In Recovery Tank",
    name: "coolantLevelInRecoveryTank",
    type: "text",
    disabled: true,
    placeholder: "Coolant Level In Recovery Tank",
    fieldGridSize: 3,
  },
  // {
  //   label: "Coolant level in radiator",
  //   name: "coolantLevelInRadiator",
  //   type: "text",
  //   disabled: true,
  //   placeholder: "Application",
  //   fieldGridSize: 3,
  // },
  {
    label: "Coolant Make",
    name: "coolantMake",
    type: "text",
    disabled: true,
    placeholder: "Coolant Make",
    fieldGridSize: 3,
  },
  {
    label: "% of coolant Additive with respect to RO Water",
    name: "collantToRoWaterPercent",
    type: "text",
    disabled: true,
    placeholder: "% of coolant Additive with respect to RO Water",
    fieldGridSize: 3,
  },
  {
    label: "Condition Of Radiator",
    name: "conditionOfRadiator",
    type: "text",
    disabled: true,
    placeholder: "Condition Of Radiator",
    fieldGridSize: 3,
  },
  // {
  //   label: "Air Cleaner Type",
  //   name: "airCleanerType",
  //   type: "text",
  //   disabled: true,
  //   placeholder: "Air Cleaner Type",
  //   fieldGridSize: 3,
  // },
  // {
  //   label: "Condition Of Air Filter",
  //   name: "conditionOfAirFilter",
  //   type: "text",
  //   disabled: true,
  //   placeholder: "Condition Of Air Filter",
  //   fieldGridSize: 3,
  // },
  // {
  //   label: "Condition Of Air Filter Hoses",
  //   name: "conditionOfAirFilterHoses",
  //   type: "text",
  //   disabled: true,
  //   placeholder: "Condition Of Air Filter Hoses",
  //   fieldGridSize: 3,
  // },
  // {
  //   label: "Last Oil Change Hours in wet air filter bowl",
  //   name: "lastOilChangeHours",
  //   type: "text",
  //   disabled: true,
  //   placeholder: "Last Oil Change Hours in wet air filter bowl",
  //   fieldGridSize: 3,
  // },
  // {
  //   label: "Air Filter Element Change Hours",
  //   name: "airFilterElementChangeHours",
  //   type: "text",
  //   disabled: true,
  //   placeholder: "Air Filter Element Change Hours",
  //   fieldGridSize: 3,
  // },
  {
    label: "Lube Oil Grade",
    name: "lubeOilGrade",
    type: "text",
    disabled: true,
    placeholder: "Lube Oil Grade",
    fieldGridSize: 3,
  },
  // {
  //   label: "Lube Oil Make",
  //   name: "lubeOilMake",
  //   type: "text",
  //   disabled: true,
  //   placeholder: "Lube Oil Make",
  //   fieldGridSize: 3,
  // },
  // {
  //   label: "Lube Oil Level in Sump",
  //   name: "lubeOilLevelInSump",
  //   type: "text",
  //   disabled: true,
  //   placeholder: "Lube Oil Level in Sump",
  //   fieldGridSize: 3,
  // },
  {
    label: "Lube Oil Condition",
    name: "lubeOilCondition",
    type: "text",
    disabled: true,
    placeholder: "Lube Oil Condition",
    fieldGridSize: 3,
  },
  {
    label: "Oil Make Filter",
    name: "oilFilterMake",
    type: "text",
    disabled: true,
    placeholder: "Oil Make Filter",
    fieldGridSize: 3,
  },
  {
    label: "Fan Belt Condition",
    name: "fanBeltCondition",
    type: "text",
    disabled: true,
    placeholder: "Fan Belt Condition",
    fieldGridSize: 3,
  },
  {
    label: "Fan Belt Tightness",
    name: "fanBeltTightness",
    type: "text",
    disabled: true,
    placeholder: "Fan Belt Tightness",
    fieldGridSize: 3,
  },
  {
    label: "Coolant Temprature",
    name: "coolantTemperature",
    type: "text",
    disabled: true,
    placeholder: "Coolant Temprature",
    fieldGridSize: 3,
  },
  {
    label: "Oil Pressure At Low Idle",
    name: "oilPressureAtLowIdle",
    type: "text",
    disabled: true,
    placeholder: "Oil Pressure At Low Idle",
    fieldGridSize: 3,
  },
  {
    label: "Oil Pressure At Hight Idle",
    name: "oilPressureAtHighIdle",
    type: "text",
    disabled: true,
    placeholder: "Oil Pressure At Hight Idle",
    fieldGridSize: 3,
  },
  {
    label: "Exhaust Smoke Condition",
    name: "exhaustSmokeCondition",
    type: "text",
    disabled: true,
    placeholder: "Exhaust Smoke Condition",
    fieldGridSize: 3,
  },
  {
    label: "Details Of observation",
    name: "detailsOfObservation",
    type: "text",
    disabled: true,
    placeholder: "Details Of observation",
    fieldGridSize: 3,
  },
  {
    label: "Defect Description",
    name: "defectDescription",
    type: "text",
    disabled: true,
    placeholder: "Defect Description",
    fieldGridSize: 3,
  },
  {
    label: "Defect Code",
    name: "defectCodeOriginal",
    type: "text",
    disabled: true,
    placeholder: "Defect Code",
    fieldGridSize: 3,
  },
  {
    label: "Action Initiated",
    name: "actionInitiated",
    type: "text",
    disabled: true,
    placeholder: "Action Initiated",
    fieldGridSize: 3,
  },
];
export const generateJIRPDF = (data) => {
  const doc = new jsPDF();
  const pageHeight = doc.internal.pageSize.height; // Height of the page
  const pageWidth = doc.internal.pageSize.width; // Width of the page
  const margin = 14;
  const maxWidth = pageWidth - (margin * 2); // Max width for text
  let currentY = 20; // Starting Y position

  const addPageIfNeeded = (requiredHeight) => {
    if (currentY + requiredHeight > pageHeight - 20) {
      doc.addPage();
      currentY = 20; // Reset Y position for new page
      return true;
    }
    return false;
  };

  // Helper function to render signatures
  const renderSignature = (label, signature, x, y) => {
    const signatureHeight = 35; // Total height needed for signature block
    addPageIfNeeded(signatureHeight);
    
    doc.setFontSize(12);
    doc.text(label, x, currentY);

    if (signature) {
      try {
        // Check if the signature is a valid image URL (e.g., a link to a hosted image)
        doc.addImage(signature, x, currentY + 5, 40, 20);
      } catch (error) {
        console.warn(`${label} has an invalid format:`, error.message);
        doc.text("Invalid", x, currentY + 12); // Show "Invalid" if the image format is invalid
      }
    } else {
      doc.text("N/A", x, currentY + 12); // Show "N/A" if no signature is provided
    }
    
    currentY += signatureHeight;
  };

  // Title
  doc.setFontSize(18);
  doc.text("Joint Inspection Report", margin, currentY);
  currentY += 10;

  // Add basic info as a table
  const basicInfoFields = data.basicInfoFields.map(([key, value]) => [
    key,
    value || "N/A",
  ]);

  autoTable(doc, {
    head: [["Field", "Value"]],
    body: basicInfoFields,
    startY: currentY,
    margin: { left: margin, right: margin },
    styles: {
      cellPadding: 3,
      fontSize: 10,
      overflow: 'linebreak',
      cellWidth: 'wrap'
    },
    columnStyles: {
      0: { cellWidth: 60 },
      1: { cellWidth: 'auto' }
    }
  });

  currentY = doc.lastAutoTable.finalY + 10;

  // Render "Details Of Observation"
  const additionalInfo = Object.fromEntries(data.additionalInfoFields);
  const detailsOfObservation =
    additionalInfo["Details Of Observation"] || "No details provided.";

  // Check if we need a new page for the section title
  addPageIfNeeded(15);
  
  doc.setFontSize(14);
  doc.setFont(undefined, 'bold');
  doc.text("Details Of Observation", margin, currentY);
  currentY += 8;
  
  doc.setFontSize(10);
  doc.setFont(undefined, 'normal');
  
  // Split text to fit width
  const observationTextLines = doc.splitTextToSize(
    detailsOfObservation,
    maxWidth
  );

  // Add text line by line, checking for page breaks
  const lineHeight = 6;
  observationTextLines.forEach((line, index) => {
    addPageIfNeeded(lineHeight);
    doc.text(line, margin, currentY);
    currentY += lineHeight;
  });
  
  currentY += 5; // Add some spacing after the text

  // Format and render "Service Maintenance Record"
  if (additionalInfo["Service Maintenance Record"]?.length > 0) {
    const serviceRecords = additionalInfo["Service Maintenance Record"].map(
      (ele) => [
        ele?.serviceNo || "N/A",
        moment(ele?.date).format("DD-MM-YYYY") || "N/A",
        ele?.hours || "N/A",
      ]
    );

    addPageIfNeeded(20);
    
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text("Service Maintenance Record", margin, currentY);
    currentY += 6;

    autoTable(doc, {
      head: [["Service No", "Date", "Hours"]],
      body: serviceRecords,
      startY: currentY,
      margin: { left: margin, right: margin },
      styles: {
        fontSize: 10,
        cellPadding: 3,
        overflow: 'linebreak'
      },
      headStyles: {
        fillColor: [66, 139, 202],
        textColor: 255,
        fontStyle: 'bold'
      }
    });

    currentY = doc.lastAutoTable.finalY + 10;
  }

  // Format and render "Past Complaints"
  if (additionalInfo["Past Complaints"]?.length > 0) {
    const pastComplaints = additionalInfo["Past Complaints"].map((ele) => [
      moment(ele?.date).format("DD-MM-YYYY") || "N/A",
      ele?.hours || "N/A",
      ele?.complaintReported || "N/A",
    ]);

    addPageIfNeeded(20);
    
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text("Past Complaints", margin, currentY);
    currentY += 6;

    autoTable(doc, {
      head: [["Date", "Hours", "Complaint Reported"]],
      body: pastComplaints,
      startY: currentY,
      margin: { left: margin, right: margin },
      styles: {
        fontSize: 10,
        cellPadding: 3,
        overflow: 'linebreak',
        cellWidth: 'wrap'
      },
      columnStyles: {
        0: { cellWidth: 35 },
        1: { cellWidth: 30 },
        2: { cellWidth: 'auto' }
      },
      headStyles: {
        fillColor: [66, 139, 202],
        textColor: 255,
        fontStyle: 'bold'
      }
    });

    currentY = doc.lastAutoTable.finalY + 10;
  }

  // Render signatures
  const simpsonEngineerSignature =
    additionalInfo["Simpson Engineer Signature"] || null;
  const oemEngineerSignature = additionalInfo["Oem Engineer Signature"] || null;

  addPageIfNeeded(20);
  doc.setFontSize(14);
  doc.setFont(undefined, 'bold');
  doc.text("Signatures", margin, currentY);
  currentY += 10;
  
  doc.setFont(undefined, 'normal');

  renderSignature(
    "Simpson Engineer Signature:",
    simpsonEngineerSignature,
    margin,
    currentY
  );

  renderSignature(
    "OEM Engineer Signature:",
    oemEngineerSignature,
    margin,
    currentY
  );

  // Save PDF
  doc.save(`JIR_Report.pdf`);
};
export const previewPdf = async (ticketId, userDetails, formData) => {
  let url = `${HOSTNAME}${REST_URLS.GET_JIR_FROM_TICKET}/checklist/${ticketId}`;
  if (userDetails.role === USER_ROLES.OEM) {
    url = `${HOSTNAME}${REST_URLS.OEM_GET_JIR_FROM_TICKET}/checklist/${ticketId}`;
  }
  const response = await invokeApi(HTTP_METHODS.GET, url);
  const keyRenameMap = {
    turboChargerType: "aspiration",
  };
  const renameKeysDeep = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map(renameKeysDeep);
    } else if (obj !== null && typeof obj === "object") {
      return Object.entries(obj).reduce((acc, [key, value]) => {
        const newKey = keyRenameMap[key] || key;
        acc[newKey] = renameKeysDeep(value);
        return acc;
      }, {});
    }
    return obj;
  };

  if (Object.keys(response).length > 0) {
    const updatedResponse = renameKeysDeep(response);

    let questionsAndAnswersSections = formatChecklistQuestions(updatedResponse);

    const doc = new jsPDF();
    doc.text("Check list", 14, 10);
    autoTable(doc, {
      body: [
        [
          {
            content: `TICKET ID : ${formData?.ticketId?.id || "1–2025–8–107"}`,
            styles: { halign: "center", fontStyle: "bold" },
          },
        ],
      ],
    });
    autoTable(doc, {
      body: [
        // Row 1: OEM + Date of Inspection
        [
          { content: "OEM :", styles: { fontStyle: "bold" } },
          { content: formData?.oem || "-", styles: { halign: "left" } },
          { content: "Date of Inspection :", styles: { fontStyle: "bold" } },
          {
            content: formData?.dateOfInspection || "-",
            styles: { halign: "left" },
          },
        ],
        // Row 2: City + State
        [
          { content: "City :", styles: { fontStyle: "bold" } },
          { content: formData?.city || "-", styles: { halign: "left" } },
          { content: "State :", styles: { fontStyle: "bold" } },
          { content: formData?.state || "-", styles: { halign: "left" } },
        ],
        // Row 3: Complaint Description
        [
          { content: "Complaint Description :", styles: { fontStyle: "bold" } },
          {
            content: formData?.complaintDescription || "",
            colSpan: 3, // span across the rest of the row
            styles: { halign: "left" },
          },
        ],
        // Row 4: Engine Serial No
        [
          { content: "Engine Serial No :", styles: { fontStyle: "bold" } },
          {
            content: formData?.engineSerialNumber || "",
            colSpan: 3,
            styles: { halign: "left" },
          },
        ],
        // Row 5: Hours Covered
        [
          { content: "Hours Covered :", styles: { fontStyle: "bold" } },
          {
            content: formData?.hoursCovered || "",
            colSpan: 3,
            styles: { halign: "left" },
          },
        ],
      ],

      theme: "grid",
      styles: {
        valign: "middle",
      },
      columnStyles: {
        0: { cellWidth: 45 },
        1: { cellWidth: 35 },
        2: { cellWidth: 45 },
        // 3: { cellWidth: 45 },
      },
      tableWidth: "auto",
    });

    // Loop through each section and generate a table
    let currentY = 80; // Initial Y position
    questionsAndAnswersSections.forEach((section, sectionIndex) => {
      // Add the title
      doc.setFontSize(14);
      // Prepare table data
      const tableData = section.questionsAndAnswers.map((item, index) => [
        item.question,
        item.answer,
      ]);

      // Add the table using autoTable
      autoTable(doc, {
        head: [[section.title, ""]],
        body: tableData,
        startY: currentY,
        margin: { top: 10 },
        didDrawPage: (questionsAndAnswersSections) => {
          currentY = questionsAndAnswersSections.cursor.y + 10; // Update Y position after the table
        },
      });

      // Add a page break if not enough space for next section
      if (
        sectionIndex < questionsAndAnswersSections.length - 1 &&
        currentY + 30 > 280
      ) {
        doc.addPage();
        currentY = 10; // Reset Y position for new page
      }
    });

    // Open PDF in a new tab
    window.open(doc.output("bloburl"));
  } else {
    toast.error("Checklist not filled");
  }
};
export const WARRANTY_STATUS = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];
